import vid1 from "../imgs/vid2.mp4";
import a1 from "../imgs/logo.jpg"
import a2 from "../imgs/profil.jpg"
import imgk from "../imgs/img22.jpg"
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Footer from "./Footer";
import Explore from "./Explore";
import a5 from "../imgs/collage1.jpg"

import img1 from "../imgs/1.jpg"
import img2 from "../imgs/2.jpg"
import img3 from "../imgs/3.jpg"
import img4 from "../imgs/4.jpg"
import img5 from "../imgs/5.jpg"
import app from "../imgs/ppt.jpg"
const Home = () => {
    const nav = useNavigate();

    const [keysrch, setsrch] = useState('');
    return (
        <>
            <div className="homeban">
                <div className="msrch">
                    <input onChange={(e)=>setsrch(e.target.value)} type="text" placeholder="Search High quality images" className="srchvalt form-control" ></input>
                    <button onClick={()=>nav(`/search?srch=${keysrch}`)} className="btn srchbtn bg-transparent"> <i class="fa-solid fa-magnifying-glass"></i> </button>
                </div>
                <div className="ides">
                    <div className="ap" onClick={()=>nav(`/search?srch=Ocean`)}> Ocean </div>
                    <div className="ap" onClick={()=>nav(`/search?srch=Tigers`)}> Tigers </div>
                    <div className="ap" onClick={()=>nav(`/search?srch=Pears`)}> Pears </div>
                    <div className="ap" onClick={()=>nav(`/search?srch=Plants`)}> Plants </div>
                </div>

            </div>

            <div className="container mt-5">
                <div className="kapp">
                    <div className="apt">
                        <p>
                            <i class="fa-solid fa-download"></i>  100k
                            Downloads
                        </p>
                    </div>
                    <div className="apt">
                        <p>
                            <i class="fa-solid fa-user"></i>
                            100k
                            Users
                        </p>
                    </div>
                    <div className="apt">
                        <p> <i class="fa-solid fa-photo-film"></i>
                            100K

                            Photos
                        </p>
                    </div>
                </div>
            </div>

            <div className="robix">
            <div className="container mt-5 kppt">
                <div className="row">
                    <div className="col-lg-7">
                        <img src={app} className="img-fluid" />
                    </div>
                
                    <div className="col-lg-5 kt mt-5">
                        <p> Our mission is to empower and inspire photographers around the world to capture and share their unique perspectives through high-quality images.  
                        </p>
                        <div className="in-btw">
                        <button onClick={()=>nav('/explore')} className="btn btn-primary apbtn"> Explore </button>
                        </div>
                            </div>
                        </div>
                
            </div>
                <div className="parel">
                         <div className="redband">
                            <div className="row in-btw ">
                               
                                <div className="col-4 ">
                                    <p>
                                        Locations
                                        </p>
                                        <h1> 1990 </h1>
                                        <p>
                                        Total Snaps
                                    </p>
                                </div>
                                <div className="col-4">
                                    <p>
                                        People </p>
                                        <h1> 1990 </h1>
                                        <p>
                                        Happy Clients
                                    </p>
                                </div>
                            </div>
                            </div>
                            </div>
            </div>
            <div className="cont1">
                <div className="row akrow p-5">
                    <div className="container col-lg-6 col-md-12 contb pt-lg-4 pt-md-0 mt-5">
                        <h5>  Photo Gallery Website </h5>
                        <h3>  Devlopment </h3> <h3> Portfolio </h3> <br />
                        <h5> by himanshuverse.com  </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 p-lg-5 mt-lg-0 mt-5 wimg">
                        <img src={a5} width={"500px"} />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="in-btw pcen"> Our brilliant photographers </div>
                <div className="row mt-5">
                    <div className="col-lg-3 ">
                        <div className="box1 mt-5">
                            <img src={img2} className="img-fluid" />
                            <br /><br />
                            <div> <b>  Anna Carter </b></div>

                            <p> Hello , My name is Anna Carter. I am a professional photographer with 5 years of experience.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 mid-mt-5">
                        <div className="box1 mt-5">
                            <img src={img1} className="img-fluid" /> <br /><br />
                            <div> <b>  Oliver James </b> </div>

                            <p> Hello , My name is Oliver James. I am a professional photographer with 7 years of experience.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="box1 mt-5">
                            <img src={img5} className="img-fluid" /> <br /> <br />
                            <div> <b> William Carter </b>  </div>

                            <p>Hello , I'm William Carter. I am a professional photographer with 5 years of experience.
                            </p>

                        </div>

                    </div>
                    <div className="col-lg-3">
                        <div className="box1 mt-5">
                            <img src={img3} className="img-fluid" /> <br /> <br />
                            <div> <b> Lucy Bennett </b> </div>

                            <p>  Hello , My name is Lucy. I am a professional photographer with 7 years of experience.
                            </p>

                        </div>

                    </div>

                </div>
            </div>
            <div className="container mt-5">
                <p> Over 5.8 million+ high quality stock images, videos and music shared by our talented community. </p>
            </div>
            <Explore />
        </>
    );
};

export default Home;
